import { useMedplum } from '@medplum/react'
import type { Patient } from '@medplum/fhirtypes'
import { useQuery } from '@tanstack/react-query'

export const medplumPatientQueryKey = (patientId: string) =>
  ['medplum-patient', { patientId }] as const

export function useMedplumPatient(patientId: string | undefined) {
  const medplum = useMedplum()

  return useQuery<Patient>({
    queryKey: patientId
      ? medplumPatientQueryKey(patientId)
      : ['medplum-patient', { patientId: 'none' }],
    enabled: !!patientId,
    staleTime: 1000 * 60 * 60,
    retry: false,
    queryFn: async () => medplum.readResource('Patient', patientId!),
  })
}
